import { useOnce } from '@prophecy/utils/react/hooks';
import { nanoid } from 'nanoid';

import { getBasicFormDataChanges } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useBasicFormData = (transpilerId: string, disabled?: boolean) => {
  return useRestQuery(
    [QueryKey, 'BasicFormdataEntities', useOnce(nanoid)],
    () => getBasicFormDataChanges(transpilerId),
    {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: !!transpilerId && !disabled,
      sentryTag: 'transpiler.getBasicFormDataAndEntities'
    }
  );
};
